import { render, staticRenderFns } from "./LegacyDropdown.vue?vue&type=template&id=931df772&scoped=true&"
import script from "./LegacyDropdown.vue?vue&type=script&lang=js&"
export * from "./LegacyDropdown.vue?vue&type=script&lang=js&"
import style0 from "./LegacyDropdown.vue?vue&type=style&index=0&id=931df772&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "931df772",
  null
  
)

export default component.exports